import React from "react";
import { motion } from "framer-motion";
import { Award, RotateCcw, ArrowRight } from "lucide-react";
import { Confetti } from "@/components/Confetti";

export function MissionComplete({ onPracticeAgain, onContinue }) {
  return (
    <div className="fixed inset-0 z-[55] flex items-center justify-center bg-[#1F2937]/70 p-4 backdrop-blur-sm" data-testid="mission-complete-screen">
      <Confetti count={120} />
      <motion.div
        initial={{ scale: 0.85, y: 30, opacity: 0 }}
        animate={{ scale: 1, y: 0, opacity: 1 }}
        transition={{ type: "spring", stiffness: 240, damping: 20 }}
        className="relative w-full max-w-lg rounded-[32px] border border-[#E5DECF] bg-white p-8 sm:p-10 text-center shadow-2xl"
      >
        <div className="text-xs uppercase tracking-widest font-bold text-[#F59E0B]">Mission 1</div>
        <h2 className="mt-1 font-heading text-3xl sm:text-4xl font-extrabold text-[#1F2937]">MISSION COMPLETE</h2>
        <p className="mt-2 font-body text-[#6B7280]">You unlocked your first three cursive letters!</p>

        {/* a — b — c connector */}
        <div className="mt-6 flex items-center justify-center gap-2">
          {["a", "b", "c"].map((l, i) => (
            <React.Fragment key={l}>
              <motion.span
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{ delay: 0.3 + i * 0.2, type: "spring", stiffness: 300 }}
                className="flex h-16 w-16 items-center justify-center rounded-2xl bg-[#0D9488]/10 font-cursive text-4xl text-[#0D9488]"
              >
                {l}
              </motion.span>
              {i < 2 && <span className="h-1 w-6 rounded-full bg-[#F59E0B]" />}
            </React.Fragment>
          ))}
        </div>

        <motion.div
          initial={{ scale: 0, rotate: -20 }}
          animate={{ scale: 1, rotate: 0 }}
          transition={{ delay: 0.9, type: "spring", stiffness: 260 }}
          className="mt-7 inline-flex flex-col items-center gap-2 rounded-3xl bg-gradient-to-b from-[#F59E0B] to-[#D97706] px-8 py-5 text-white shadow-lg"
        >
          <Award size={44} strokeWidth={2} />
          <div className="font-heading text-lg font-extrabold">Cursive Starter Badge</div>
        </motion.div>

        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <button
            onClick={onPracticeAgain}
            data-testid="mission-practice-again-button"
            className="inline-flex flex-1 items-center justify-center gap-2 rounded-2xl bg-[#F2ECE1] px-6 py-4 text-base font-bold text-[#1F2937] transition-all hover:bg-[#E5DECF] active:translate-y-0.5"
          >
            <RotateCcw size={18} /> Practice Again
          </button>
          <button
            onClick={onContinue}
            data-testid="mission-continue-button"
            className="inline-flex flex-1 flex-col items-center justify-center rounded-2xl bg-[#0D9488] px-6 py-3 font-bold text-white shadow-md transition-all hover:bg-[#0B7F74] active:translate-y-0.5"
          >
            <span className="inline-flex items-center gap-2">Continue <ArrowRight size={18} /></span>
            <span className="text-[11px] font-medium opacity-80">More cursive missions coming soon</span>
          </button>
        </div>
      </motion.div>
    </div>
  );
}
